// src/components/Footer.js
import React from 'react';
import { Container } from 'react-bootstrap';

function Footer() {
  return (
    <footer className="bg-dark text-center text-light py-3">
      <Container>
        <small>© {new Date().getFullYear()} BTG Solutions, Inc. All rights reserved.</small>
      </Container>
    </footer>
  );
}

export default Footer;
